import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed') as any;

class VideoEmbed extends BlockEmbed {
  static create(value: string | { url?: string }) {
    const node = super.create();
    
    // Extrair URL do valor (pode ser string ou objeto)
    let url = '';
    if (typeof value === 'string') {
      url = value;
    } else if (value && typeof value === 'object' && value.url) {
      url = value.url;
    }
    
    // Extrair ID do YouTube ou Vimeo e converter para URL de embed
    let embedUrl = '';
    
    if (url) {
      if (url.includes('youtube.com/watch') || url.includes('youtu.be/')) {
        // YouTube
        const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/;
        const match = url.match(youtubeRegex);
        if (match) {
          embedUrl = `https://www.youtube.com/embed/${match[1]}`;
        }
      } else if (url.includes('vimeo.com/')) {
        // Vimeo
        const vimeoRegex = /vimeo\.com\/(\d+)/;
        const match = url.match(vimeoRegex);
        if (match) {
          embedUrl = `https://player.vimeo.com/video/${match[1]}`;
        }
      } else if (url.includes('youtube.com/embed') || url.includes('player.vimeo.com')) {
        // Já é uma URL de embed
        embedUrl = url;
      } else if (url.startsWith('http')) {
        // Tentar usar como URL direta de embed
        embedUrl = url;
      }
    }
    
    if (embedUrl) {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', embedUrl);
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', 'true');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.style.width = '100%';
      iframe.style.height = '400px';
      iframe.style.maxWidth = '100%';
      iframe.style.border = 'none';
      iframe.style.borderRadius = '8px';
      node.appendChild(iframe);
    } else {
      // Se não conseguir converter, mostrar a URL como texto
      node.textContent = url || '';
    }
    
    return node;
  }
  
  static value(node: HTMLElement) {
    const iframe = node.querySelector('iframe');
    return iframe ? iframe.getAttribute('src') || '' : node.textContent || '';
  }
}

(VideoEmbed as any).blotName = 'video';
(VideoEmbed as any).tagName = 'div';
(VideoEmbed as any).className = 'ql-video';

// Permitir iframes no sanitize
(VideoEmbed as any).sanitize = (url: string) => {
  if (!url) return '';
  
  // Permitir URLs do YouTube, Vimeo e outras URLs de embed
  if (url.includes('youtube.com') || url.includes('youtu.be') || url.includes('vimeo.com') || url.includes('player.vimeo.com')) {
    return url;
  }
  // Permitir URLs que começam com http/https
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return '';
};

// Variável para controlar se já foi registrado
let videoEmbedRegistered = false;

export function registerVideoEmbed() {
  if (videoEmbedRegistered) return;
  
  try {
    Quill.register(VideoEmbed as any, true);
    videoEmbedRegistered = true;
  } catch (e) {
  }
}

